import { EPaymentCreationType, schemes, zSchema } from "@zeal/common";
import { createTransactionResponseSchema } from "../../../OdoClient/schemas";

export const createPaymentRequestSchema = zSchema.object({
  addenda: zSchema.string().max(80).optional(),
  amount: zSchema.number().positive().optional(),
  companyID: schemes.companyID(),
  contractorID: schemes.mongoObjectId().optional(),
  contractorPaymentGroupID: schemes.uuid().optional(),
  contractorPaymentID: schemes.mongoObjectId().optional(),
  description: zSchema.string().max(10).optional(),
  employeeID: schemes.mongoObjectId().optional(),
  employeeCheckID: schemes.uuid().optional(),
  employerCheckID: schemes.mongoObjectId().optional(),
  externalNote: zSchema.string().max(500).optional(),
  internalNote: zSchema.string(),
  speed: zSchema.enum(["same_day", "next_day"]),
  type: zSchema.nativeEnum(EPaymentCreationType),
});

export type TCreatePaymentRequestSchema = zSchema.TypeOf<
  typeof createPaymentRequestSchema
>;

export const createPaymentResponseSchema = createTransactionResponseSchema;

export type TCreatePaymentResponseSchema = zSchema.TypeOf<
  typeof createPaymentResponseSchema
>;
